<template>
    <div :class="`${surveyMode ? 'date-picker-sublabel-mode' : ''}`">
        <p v-if="surveyMode" class="surveys-common-label pb-0 mb-1" >
          {{`${requiredCharLabel}`}}
          <span v-if="sublabel" class="surveys-common-sublabel"><br> {{sublabel}}</span>
      </p>
        <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
            :disabled="readonly"
        >
            <template v-slot:activator="{ on, attrs }">
            <v-text-field
                color="success"
                filled
                outlined
                dense
                v-model="computedDateFormatted"
                :label="surveyMode ? '' : requiredCharLabel"
                :append-icon="hideIcon ? '' : 'mdi-calendar'"
                hide-details="auto" 
                v-bind="attrs"
                v-on="on"
                :rules="rule"
                :error-messages="errorMessages"
                :readonly="readonly"
            ></v-text-field>
            </template>
            <v-date-picker
            v-model="value"
            @input="menu = false"
            :min="min"
            :readonly="readonly"
            :allowed-dates="allowedDates"
            ></v-date-picker>
        </v-menu>
    </div>
</template>

<script>
export default {
    props: ['valueInput', 'rule', 'label', 'errorMessages', 'hideIcon', 'min', 'readonly', 'allowedDates', 'sublabel', 'surveyMode'],
    model: {
        prop: 'value',
        event: 'valueChange'
    },
    computed: {
        value: {
            get: function() {
                return this.valueInput
            },
            set: function(value) {
                this.$emit('valueChange', value)
            }
        },
        computedDateFormatted: {
            
            get: function() {
               return this.formatDate(this.value)
            },
            set: function() {
               
            }
        },
        requiredCharLabel:{
            get: function(){
                if(this.label == "" || this.label == undefined)
                    return "";
                const response = this.label + " *";
                for (let i = 0; i < (this?.rule?.length??[]); i++) {
                    if(this.rule[i]("") != true){
                        return response;
                    }
                }
                return this.label;
            }
        }
    },
    data: () =>({
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
    }),
    methods: {
        formatDate (date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        }
    },
}
</script>
<style lang="scss" >
   
    
   .date-picker-sublabel-mode .v-text-field .v-input__control .v-input__slot input{
        // //margin-bottom: 8px;
        margin-top: 0px !important;
        padding: 0;
    }
    .date-picker-sublabel-mode .v-text-field .v-input__control .v-input__slot input{
    //margin-bottom: 8px;
        margin-top: 1px !important;
        padding: 0;
    }
</style>